import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import CommonTable from '../Shared/Tables/TableV1.tsx';

const KnowledgeMapTable = ({ data, subject, className, topicColors = [], forPdf = false }) => {

  if (!data || !data.topics) return null;

  const tableData = [];

  data.topics.forEach((topic, topicIdx) => {
    const topicColor = topicColors[topicIdx % topicColors.length] || '#3b82f6';

    topic.subtopics?.forEach((subtopic) => {
      // ✅ FIX: fallback for prerequisites
      const prerequisites = subtopic.prerequisites?.length
        ? subtopic.prerequisites
        : topic.topic_prerequisites || [];

      const prereqNames = [];

      const flattenPrereqs = (prereqList, level = 0, parentPrefix = '') => {
        prereqList.forEach((prereq, idx) => {
          const name = typeof prereq === 'object' ? prereq?.name : prereq;
          if (!name) return;

          let prefix, indent;
          if (level === 0) {
            prefix = String.fromCharCode(65 + idx) + '.';  // A. B. C.
            indent = '';
          } else {
            prefix = parentPrefix + (idx + 1);              // A.1  A.2  B.1
            indent = '    '.repeat(level);
          }

          prereqNames.push({ name: indent + prefix + ' ' + name, level });

          if (typeof prereq === 'object' && prereq?.children?.length) {
            flattenPrereqs(prereq.children, level + 1, prefix + '.');
          }
        });
      };
      flattenPrereqs(prerequisites);

      tableData.push({
        id: `${topic.topic}-${subtopic.subtopic}`,
        topic: topic.topic,
        topicColor,
        subtopic: subtopic.subtopic,
        description: subtopic.description || topic.description || '-',
        prerequisites:
          prereqNames.map((p) => p.name).join('\n') || '-',
        learningMaterial: subtopic.learning_material?.length
          ? subtopic.learning_material.join(', ')
          : topic.learning_material?.length
            ? topic.learning_material.join(', ')
            : '-',
      });
    });
  });

  const columns = [
    {
      accessorKey: 'topic',
      header: 'Topic',
      size: 150,
      Cell: ({ cell, row }) => (
        <Box
          sx={{
            backgroundColor: row.original.topicColor,
            color: '#fff',
            padding: '4px 8px',
            borderRadius: '4px',
            display: 'inline-block',
          }}
        >
          {cell.getValue()}
        </Box>
      ),
    },
    {
      accessorKey: 'subtopic',
      header: 'Subtopic',
      size: 200,
    },
    {
      accessorKey: 'description',
      header: 'Description',
      size: 250,
    },
    {
      accessorKey: 'prerequisites',
      header: 'Prerequisites',
      size: 250,
      Cell: ({ cell }) => (
        <Box sx={{ whiteSpace: 'pre-line' }}>{cell.getValue()}</Box>
      ),
    },
    {
      accessorKey: 'learningMaterial',
      header: 'Learning Materials',
      size: 200,
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        overflow: 'visible',
        height: 'auto',
        '& .MuiTableHead-root': {
          position: 'static !important',
        },
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Knowledge Map: Class {className} - {subject}
      </Typography>

      <CommonTable
        columns={columns}
        data={tableData}
        enableTopToolbar={false}
        enableColumnFilters={false}
        enableColumnActions={false}
        enablePagination={false}
        enableBottomToolbar={!forPdf}
        enableTableFooter={!forPdf}

        // ✅ CRITICAL FIXES FOR PDF
        enableRowVirtualization={false}

        muiTableContainerProps={{
          sx: forPdf
            ? {
              maxHeight: 'none !important',
              height: 'auto !important',
              overflow: 'visible !important',
              width: '100%',
            }
            : {
              maxHeight: 'calc(100vh - 200px)',
              width: '100%',
            },
        }}

        muiTableBodyProps={{
          sx: {
            display: 'table-row-group',
          },
        }}
      />
    </Paper>
  );
};

export default KnowledgeMapTable;